'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ENV = enviro.getShort();

var TallyLoaderUtil = function () {
  function TallyLoaderUtil() {
    _classCallCheck(this, TallyLoaderUtil);
  }

  _createClass(TallyLoaderUtil, [{
    key: 'addTallyScriptToPage',
    value: function addTallyScriptToPage(id, src, onLoad) {
      var body = document.querySelector('body');
      var script = document.createElement('script');

      if (onLoad) {
        script.onload = onLoad;
      }

      script.id = id;
      script.src = src;
      body.appendChild(script);
    }
  }, {
    key: 'doesTallyAlreadyExist',
    value: function doesTallyAlreadyExist(id) {
      return document.getElementById(id);
    }
  }, {
    key: 'getPortal',
    value: function getPortal(portals) {
      return portals[ENV];
    }
  }, {
    key: 'getTallyId',
    value: function getTallyId(portal) {
      return 'tally-' + portal;
    }
  }, {
    key: 'getTallySrc',
    value: function getTallySrc(portal) {
      return 'https://app.gettally' + (ENV === 'qa' ? 'qa' : '') + '.com/tallyembed/' + portal + '.js';
    }
  }, {
    key: 'isTallyDisabledLocally',
    value: function isTallyDisabledLocally() {
      return window.localStorage && window.localStorage.getItem('DISABLE_LOCAL_TALLY') === "true";
    }
  }]);

  return TallyLoaderUtil;
}();

exports.default = TallyLoaderUtil;
;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/tally-loader-react/static-1.63/js/TallyLoaderUtil.js
// module id = 277
// module chunks = 0